import { Outlet } from 'react-router-dom';

import { BonfireSidebar } from '@/components/layout/Bonfire/BonfireSidebar';
import '@/features/bonfire/bonfire.css';

export function BonfireLayout() {
  return (
    <div className="flex flex-1 min-w-0 overflow-hidden">
      <BonfireSidebar />
      {/* .bonfire scopes the ported CSS tokens/fonts so they don't leak into the rest of the app. */}
      <main className="bonfire flex-1 min-w-0 min-h-0 flex flex-col">
        <Outlet />
      </main>
    </div>
  );
}
